import { Rate } from 'antd'
import type { FC } from 'react'
import { useCallback, useEffect, useMemo, useState } from 'react'

import type { EventComment } from '../../../../../api/interfaces/Comments/comments.model'
import { commentsAPI } from '../../../../../axios/axios'
import { SendComment } from '../../../../../components/atoms'
import { EmptyData } from '../../../../../components/atoms/EmptyData/EmptyData'
import { MessagesNotification } from '../../../../../components/atoms/MessagesNotification'
import { PresentationCard } from '../../../../../components/atoms/PresentationCard'
import type { ICommentFields } from '../../../../../components/atoms/SendComment/SendComment'
import {
  CommentWrapper,
  ContentWrapp,
  SBodyTextWrapp,
  SCreated,
  SFooterComment,
  SHeaderTitle,
  SSButton,
  SText,
  STitleText,
} from './Comment.styled'

interface ICommentsProps {
  id: number
  eventName: string
}

const TIME_OUT = 3000
const messageSuccess = 'Ваш комментарий был успешно добавлен'
const messageError = 'Что-то пошло не так, попробуйте еще раз'

export const Comment: FC<ICommentsProps> = ({ id, eventName }) => {
  const [commentsData, setCommentsData] = useState<EventComment[]>([])
  const [response, setResponse] = useState<boolean>()
  const [visibleMessage, setVisibleMessage] = useState(false)

  const message = response ? messageSuccess : messageError
  const messageType = response ? 'success' : 'danger'

  const callbackdata = useCallback(
    async (values: ICommentFields) => {
      try {
        const { theme, message_text: messageText, rate } = values

        const params = {
          caption: theme,
          body: messageText,
          rating: Number(rate),
          event_name: eventName,
          event_id: id,
        }
        const res = await commentsAPI.postsComments(params)
        const { success } = res.data
        setResponse(success)
      } catch (e) {
        console.error(e)
      }
    },
    [eventName, id],
  )

  const comments = useMemo(() => {
    if (commentsData.length) {
      return commentsData.map((c) => (
        <PresentationCard
          key={c.FIO}
          header={<SHeaderTitle>{c.FIO}</SHeaderTitle>}
          body={
            <SBodyTextWrapp>
              <STitleText>{c.caption}</STitleText>
              <SText>{c.body}</SText>
            </SBodyTextWrapp>
          }
          footer={
            <SFooterComment>
              <Rate value={c.rating} disabled />
              <SCreated>{c.created}</SCreated>
            </SFooterComment>
          }
        />
      ))
    }
    return <EmptyData />
  }, [commentsData])

  const getComments = useCallback(async () => {
    try {
      const res = await commentsAPI.getEventComment(id)
      const { data } = res.data
      setCommentsData(data)
    } catch (e) {
      console.error(e)
    }
  }, [id])

  useEffect(() => {
    getComments()
  }, [getComments])

  useEffect(() => {
    let timeOut: NodeJS.Timeout
    if (response) {
      setVisibleMessage((prev) => !prev)
      timeOut = setTimeout(() => {
        setVisibleMessage((prev) => !prev)
      }, TIME_OUT)
    }
    return () => clearTimeout(timeOut)
  }, [response])

  return (
    <CommentWrapper>
      <SSButton>
        <SendComment callbackData={callbackdata} />
      </SSButton>
      <ContentWrapp>{comments}</ContentWrapp>
      <MessagesNotification
        message={message}
        open={visibleMessage}
        title="Уведомление"
        type={messageType}
      />
    </CommentWrapper>
  )
}
